<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          v-for="(item, index) in errors"
          :key="index"
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-text-field
          :value="value.crNumber"
          label="CR Number"
          @input="update('crNumber', $event)"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          :value="value.name"
          label="Name"
          @input="update('name', $event)"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          :value="value.dateOfReciept"
          type="date"
          label="Date Of Reciept"
          @input="update('dateOfReciept', $event)"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          :value="value.dateDue"
          type="date"
          label="Due Date"
          @input="update('dateDue', $event)"
        />
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="loading"
          @click="$emit('submit')"
        >
          {{ submitLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import searchDelay from '@/extra-functions/searchDelay.extra'

  // Shared by Create and Edit so the two stay identical — each parent supplies
  // only its own submit handler and button label.
  export default {
    name: 'ConsumerLoanForm',
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      errors: {
        type: Array,
        default: () => [],
      },
      loading: Boolean,
      submitLabel: {
        type: String,
        default: 'Save',
      },
    },
    watch: {
      'value.crNumber' (val) {
        const regX = /\s/ig
        if (val && regX.test(val)) {
          this.typing(() => {
            this.update('crNumber', val.replace(regX, ''))
          })
        }
      },
    },
    created () {
      // Per instance: the Edit dialog is eager, so both forms are mounted at
      // once and a shared debounce would let one cancel the other's strip
      this.typing = searchDelay(300)
    },
    methods: {
      update (key, val) {
        this.$emit('input', { ...this.value, [key]: val })
      },
    },
  }
</script>
